import type { IModuleDefinition } from '@platform/core/types';
import { collectionTypeOf } from './collectionModel';
import { useLibraryCollections } from './useLibraryCollections';

/**
 * Кількість бібліотек бази знань простору для лічильника пункту «Бібліотеки» лівого меню (прототип v4 kbNavMain: (ws.kbLibs || []).length):
 * число, коли модуль має тип добірок і їх прочитано; інакше undefined (лічильника немає).
 */
export function useLibraryCount(ws: string, module: IModuleDefinition | undefined, rtKey: string): number | undefined {
  const collectionRt = module ? collectionTypeOf(module, rtKey) : undefined;
  const { collections, isLoading, error } = useLibraryCollections(ws, collectionRt);
  return collectionRt && !isLoading && !error ? collections.length : undefined;
}
